import { render, staticRenderFns } from "./v-file.vue?vue&type=template&id=a9c809d2&scoped=true&"
import script from "./v-file.vue?vue&type=script&lang=js&"
export * from "./v-file.vue?vue&type=script&lang=js&"
import style0 from "./v-file.vue?vue&type=style&index=0&id=a9c809d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c809d2",
  null
  
)

export default component.exports